import { render, staticRenderFns } from "./writers.vue?vue&type=template&id=49e8afa7"
import script from "./writers.vue?vue&type=script&lang=js"
export * from "./writers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports